import { render } from "./WelcomeNotification.vue?vue&type=template&id=21ea4604&scoped=true"
import script from "./WelcomeNotification.vue?vue&type=script&lang=js"
export * from "./WelcomeNotification.vue?vue&type=script&lang=js"

import "./WelcomeNotification.vue?vue&type=style&index=0&id=21ea4604&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ea4604"]])

export default __exports__